var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.02405 32.63L4.78809 35.677C5.15464 36.3184 5.68156 36.8224 6.30011 37.189L12.6002 26.2841H0C0 26.9943 0.183276 27.7045 0.549828 28.3459L3.02405 32.63Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.4548L13.6999 2.54984C13.0813 2.91639 12.5544 3.4204 12.1879 4.06186L0.549828 24.2222C0.190017 24.8499 0.000479067 25.5606 0 26.2841H12.6002L20 13.4548Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6999 37.189C34.3185 36.8224 34.8454 36.3184 35.2119 35.677L35.945 34.4169L39.4502 28.3459C39.8167 27.7045 40 26.9943 40 26.2841H27.3989L30.0802 31.5533L33.6999 37.189Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.4548L26.3001 2.54983C25.6815 2.18328 24.9713 2 24.2382 2H15.7617C15.0286 2 14.3184 2.20619 13.6999 2.54983L20 13.4548Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3998 26.2841H12.6002L6.30011 37.189C6.91867 37.5556 7.62886 37.7388 8.36197 37.7388H31.638C32.3711 37.7388 33.0813 37.5326 33.6999 37.189L27.3998 26.2841Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6312 14.142L27.8121 4.06186C27.4456 3.4204 26.9187 2.91639 26.3001 2.54984L20 13.4548L27.3998 26.2841H39.9771C39.9771 25.5739 39.7938 24.8637 39.4273 24.2222L33.6312 14.142Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.7388,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/Google_Drive.1dea9756e89f675585271c2e73ac7541.svg";
export { ForwardRef as ReactComponent };